/**
 * „Morse“ im Menü unter „Täglich“ zeigen oder ausblenden. (06.10.2026, Morse-Modul Bahn 1)
 *
 * 08.10.2026 (Martin): „Der Morse-Code ist, wenn er aktiviert ist, etwas Tägliches, und
 * nicht irgendetwas, wo du etwas aufklappen musst.“ Er stand in „Mehr“, jetzt unter
 * „Täglich“ (index.html). Die Regel selbst ist unverändert.
 *
 * Nur Konto 1 und nur mit dem Schalter „Morse im Menü“ (Einstellungen →
 * Darstellung). Die Regel steht EINMAL in shared/morse-konto.ts; hier nur,
 * wo sie im Menü ankommt. app.ts ruft das nach dem Anmelden und bei jeder
 * Änderung der Einstellungen (`voice-v8:settings-changed`, `-sync`).
 */
import { morseAn } from "../../shared/morse-konto.js";
import { loadSettings } from "./settings.js";

/** Die Zeile im Menü (index.html, `#nav-morse-zeile`). */
export const MORSE_MENUE_ZEILE = "nav-morse-zeile";

/** Den Menüpunkt nach Konto und Schalter zeigen. Gibt zurück, ob er sichtbar ist. */
export function zeigeMorseImMenue(
  doc: Document = document,
  uid: number | null | undefined = (globalThis as { __voiceV8Uid?: number }).__voiceV8Uid,
  wert: unknown = loadSettings().morseLernen,
): boolean {
  const zeile = doc.getElementById(MORSE_MENUE_ZEILE);
  const an = morseAn(wert, uid);
  if (zeile) zeile.hidden = !an;
  return an;
}
